module.exports = __webpack_public_path__ + "img/54_51.a9a6716e.png";